import { BaseModel, Guid, RecursivePartial } from '@models/base';
import { ParamsFilter } from '@models/filters/params-filter';
import { WorkflowTriggerAction } from './workflow-trigger-action';

export class WorkflowTrigger extends BaseModel {
    id?: Guid;
    conditions?: ParamsFilter;
    actions?: WorkflowTriggerAction[];

    constructor(json?: RecursivePartial<WorkflowTrigger>) {
        super(json);
        this.parseWorkflowTrigger(json || {});
    }

    parse(json: RecursivePartial<WorkflowTrigger>): WorkflowTrigger {
        super.parse(json);
        this.parseWorkflowTrigger(json);
        return this;
    }

    private parseWorkflowTrigger(json: RecursivePartial<WorkflowTrigger>): void {
        WorkflowTrigger.assignFields(this, json, ['id']);
        WorkflowTrigger.assignClassFields(this, json, { conditions: ParamsFilter });
        WorkflowTrigger.assignClassArrays(this, json, { actions: WorkflowTriggerAction });
    }

}
